import { render, staticRenderFns } from "./ServiceStaffSetting.vue?vue&type=template&id=5e693c72"
import script from "./ServiceStaffSetting.vue?vue&type=script&lang=js"
export * from "./ServiceStaffSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports